module.exports = __webpack_public_path__ + "img/珍银面膜--OK_02.0192656b.jpg";